export const ClvrPrscPrimaryColor = '#2971B3'
